/**
 * 页面级「立即滚到某个位置」—— 内容替换 / 视图切换 / 列表复位专用。
 *
 * 为什么不能直接 `window.scrollTo({ top, behavior: "auto" })`：
 *
 * 1. `pc/landing.less` 在 `html` 上声明了 `scroll-behavior: smooth`
 *    （PC / Pad / Mobile 共用同一个 webpack bundle，这条全局规则在手机端同样生效），
 *    按规范 `behavior: "auto"` 也会被它接管成平滑滚动，没法真正“立即”跳转。
 * 2. iOS Safari（iPad / iPhone）上，平滑滚动动画进行中一旦文档高度变化就会被中断，
 *    而且不会补完。切换资讯时正文整块替换、加载态先变矮/再变高，正好命中：
 *    滚动条停在半路，看起来就是“切换资讯后没有回到顶部”。
 *
 * 所以这里统一做同步跳转：临时把 `html` 的 `scroll-behavior` 压成 `auto`，
 * 用两参数 `scrollTo` 立即跳转，再恢复原内联值；并直接写 `scrollTop`，
 * 兜底个别 iOS 版本忽略 `window.scrollTo` 的情况。
 *
 * 注意：页面内锚点跳转（需要平滑效果）不要用这个函数，继续用 scrollIntoView。
 */
export function scrollPageTo(top) {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const html = document.documentElement;
  if (!html) return;

  const prevScrollBehavior = html.style.scrollBehavior;
  /* 覆盖样式表里的 scroll-behavior: smooth，保证下面这次滚动同步完成 */
  html.style.scrollBehavior = "auto";
  try {
    /* 读一次布局，确保内联的 auto 已经参与样式计算 */
    void html.scrollHeight;

    window.scrollTo(0, top);

    /* 兜底：个别 iOS 版本会忽略上面的 window.scrollTo，直接写滚动元素的 scrollTop */
    const scrollingElement = document.scrollingElement;
    if (scrollingElement && Math.abs(scrollingElement.scrollTop - top) > 1) {
      scrollingElement.scrollTop = top;
    }
    if (Math.abs(html.scrollTop - top) > 1) {
      html.scrollTop = top;
    }
    /* 老版本 iOS：document.scrollingElement 可能指向 body */
    if (
      document.body &&
      document.body !== scrollingElement &&
      Math.abs(document.body.scrollTop - top) > 1
    ) {
      document.body.scrollTop = top;
    }
  } finally {
    html.style.scrollBehavior = prevScrollBehavior || "";
  }
}

/** 页面级同步置顶（等价于 scrollPageTo(0)） */
export function scrollPageToTop() {
  scrollPageTo(0);
}

export default scrollPageToTop;
